import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SchoolActivity } from '../../../models/SchoolActivity';
import {
	AddSchoolActivitySuccessAction,
	DeleteSchoolActivitySuccessAction,
	GetSchoolActivitiesByStatusAction,
	GetSchoolActivitiesByStatusSuccessAction,
	GetSchoolActivitiesSuccessAction,
	GetSchoolActivityByIdSuccessAction,
	UpdateSchoolActivitySuccessAction,
} from '../actions/school-activities.actions';

export const schoolActivitiesInitialState: EntityState<SchoolActivity> = {
	ids: [],
	entities: {},
};

export const schoolActivitiesAdapter: EntityAdapter<SchoolActivity> = createEntityAdapter<SchoolActivity>();

export const schoolActivitiesReducer = createReducer(
	schoolActivitiesInitialState,
	on(AddSchoolActivitySuccessAction, (state, { schoolActivity }) => schoolActivitiesAdapter.upsertOne(schoolActivity, state)),
	on(GetSchoolActivitiesSuccessAction, (state, { schoolActivities }) => {
		if (schoolActivities) {
			return schoolActivitiesAdapter.upsertMany(schoolActivities, state);
		}
		return state;
	}),
	on(GetSchoolActivitiesByStatusAction, (state, { req }) => {
		return state;
	}),
	on(GetSchoolActivitiesByStatusSuccessAction, (state, { schoolActivities, setAll }) => {
		if (setAll && schoolActivities) {
			return schoolActivitiesAdapter.setAll(schoolActivities, state);
		}
		if (schoolActivities) {
			return schoolActivitiesAdapter.upsertMany(schoolActivities, state);
		}
		return schoolActivitiesAdapter.removeAll(state);
	}),
	on(GetSchoolActivityByIdSuccessAction, (state, { schoolActivity }) => {
		return schoolActivitiesAdapter.upsertOne(schoolActivity, state);
	}),
	on(UpdateSchoolActivitySuccessAction, (state, { schoolActivity }) => {
		return schoolActivitiesAdapter.upsertOne(schoolActivity, state);
	}),
	on(DeleteSchoolActivitySuccessAction, (state, { activityId }) => {
		return schoolActivitiesAdapter.removeOne(activityId, state);
	})
);
